// middleware
import { compact, flatten, map, isNaN } from 'underscore';
import { api, cleanQuery } from '../middleware/client';

const BASE_URL = `${process.env.REACT_APP_REST_URI}`;

function typeahead_firm({ search, officeType }, callback) {
  let url = `${BASE_URL}/office/search`;
  return typeahead(
    url,
    {
      search,
      officeType
    },
    callback
  );
}

function typeahead_brokerage(search, callback) {
  return typeahead_firm(
    {
      search,
      officeType: 'brokerage'
    },
    callback
  );
}

function typeahead_service_company(search, callback) {
  return typeahead_firm(
    {
      search,
      officeType: 'service_company'
    },
    callback
  );
}

function typeahead(url, query = { search: '' }, callback) {
  let request = api.get(url, {
    query: cleanQuery(query)
  });

  if (callback) {
    request.then(response => callback(response));
  }

  return request;
}

function typeahead_community(search, callback) {
  const url = `${BASE_URL}/community/search`;
  return typeahead(url, { search }, callback);
}

function typeahead_poi(search, callback) {
  const url = `${BASE_URL}/poi/search`;
  return typeahead(url, { search }, callback);
}

function typeahead_assisted_living(search, callback) {
  const url = `${BASE_URL}/assisted-living/search`;
  return typeahead(url, { search }, callback);
}

function typeahead_golf_course(search, callback) {
  const url = `${BASE_URL}/golf-course/search`;
  return typeahead(url, { search }, callback);
}

// prettier-ignore
const collierCountyZipCodes = ["34101", "34102", "34103", "34104", "34105", "34106", "34107", "34107", "34108", "34108", "34109", "34110", "34112", "34113", "34114", "34116", "34117", "34119", "34120", "34137", "34138", "34139", "34140", "34142", "34143", "34145", "34146"];
// prettier-ignore
const charlotteCountyZipCodes = ["33927", "33938", "33946", "33947", "33947", "33948", "33949", "33950", "33951", "33952", "33953", "33954", "33955", "33980", "33980", "33981", "33982", "33983", "33983"];
// prettier-ignore
const leeCountyZipCodes = ["33901", "33902", "33903", "33903", "33904", "33905", "33905", "33906", "33907", "33908", "33909", "33910", "33910", "33911", "33912", "33913", "33913", "33914", "33915", "33916", "33917", "33917", "33918", "33918", "33919", "33920", "33921", "33922", "33924", "33928", "33931", "33932", "33936", "33945", "33956", "33957", "33970", "33971", "33972", "33990", "33990", "33991", "33993", "33993", "33994", "34133", "34134", "34134", "34135", "34136"];
function populateZipCodes(zipCodes) {
  var mZipCodes = [];

  zipCodes.forEach(function (zipCode) {
    const mCoolierCounty = collierCountyZipCodes.filter(
      zip => zip.indexOf(zipCode) !== -1
    );
    const mCharlotteCounty = charlotteCountyZipCodes.filter(
      zip => zip.indexOf(zipCode) !== -1
    );
    const mLeeCounty = leeCountyZipCodes.filter(zip => zip.indexOf(zipCode) !== -1);

    mCoolierCounty.forEach(zipCode =>
      mZipCodes.push({
        label: `Collier County: ${zipCode}`,
        value: zipCode
      })
    );

    mCharlotteCounty.forEach(zipCode =>
      mZipCodes.push({
        label: `Charlotte County: ${zipCode}`,
        value: zipCode
      })
    );

    mLeeCounty.forEach(zipCode =>
      mZipCodes.push({
        label: `Lee County: ${zipCode}`,
        value: zipCode
      })
    );
  });

  return mZipCodes;
}
// prettier-ignore
const CITIES = ['Naples', 'Marco Island', 'Everglades City', 'Ave Maria', 'Immokalee', 'Goodland', 'Bonita Springs', 'Estero', 'Cape Coral', 'Ft. Myers', 'Ft. Myers Beach', 'North Ft. Myers', 'Lehigh Acres', 'Labelle', 'Sanibel', 'Captiva', 'Port Charlotte', 'Punta Gorda'];
function searchCities(names) {
  let cities = CITIES.map(city => city.toLowerCase());

  return Promise.resolve(
    map(
      compact(
        flatten(
          map(names, name =>
            map(cities, (city, i) => {
              if (city.indexOf(name) > -1 || name.indexOf(city) > -1) {
                return CITIES[i];
              }
            })
          )
        )
      ),
      city => ({ label: city, value: city })
    )
  );
}

async function typeahead_location(query, callback) {
  const search = (query.search || '').trim().toLowerCase().replace(/(\s)+/g, ' ');
  const propertyClass = query.propertyClass || 'residential';

  if (search === '') {
    return callback([]);
  }

  const list = [],
    cities = await searchCities([search]),
    zipCodes = populateZipCodes([search]),
    searchCommunities =
      propertyClass !== 'commercial' &&
      String(parseInt(search, 10)) !== search &&
      isNaN(parseInt(search.split(' ')[0], 10));

  var searchDevelopmentsRequest;

  if (cities.length > 0) {
    list.push({
      label: 'Cities',
      options: cities.map(({ label, value }) => ({
        label,
        value,
        field: 'city'
      }))
    });
  }

  list.push({
    label: 'Search By',
    options: compact([
      search &&
        search[0] === '2' &&
        search.length === 9 && {
          label: 'MLS Number',
          value: query.search,
          field: 'mlsNumber'
        },
      {
        label: 'Search by Address',
        value: query.search,
        field: 'fullAddress'
      }
    ])
  });

  var communities = {
    label: 'Communities',
    options: [
      {
        label: '...Loading...',
        value: undefined,
        field: 'communityName'
      }
    ]
  };

  if (searchCommunities) {
    searchDevelopmentsRequest = typeahead_community(search);
    list.push(communities);
  }

  if (zipCodes.length > 0) {
    list.push({
      label: 'Zip Codes',
      options: zipCodes.map(({ label, value }) => ({
        label,
        value,
        field: 'postalCode'
      }))
    });
  }

  callback(list);

  if (searchCommunities) {
    searchDevelopmentsRequest.then(function (options) {
      if (options && options.length > 0) {
        communities.options = options.map(({ label, value }) => ({
          label,
          value,
          field: 'communityName'
        }));
      } else {
        communities.options = [
          {
            label: 'No Communities Found',
            value: undefined,
            field: 'communityName'
          }
        ];
      }

      callback(list.concat([]));
    });
  }

  return searchDevelopmentsRequest;
}

const initialState = {};
function reducer(state = initialState, action) {
  return state;
}

export {
  typeahead_firm,
  typeahead_brokerage,
  typeahead_service_company,
  typeahead_community,
  typeahead_poi,
  typeahead_assisted_living,
  typeahead_golf_course,
  typeahead_location
};
export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/Shared.js